module.exports = __webpack_public_path__ + "static/img/app-logo.a7d1b4a6.png";